import { Builder } from "@builder.io/react";

import type { DeprecatedColorKeys } from "@/styles/deprecated-colors";
import { deprecatedColors } from "@/styles/deprecated-colors";

import { interactiveElementsComponentsNames } from "../consts";

export interface RotatingTextProps {
  image: string;
  rotatingTextColor: DeprecatedColorKeys;
}

export const RotatingTextButton = ({
  rotatingTextColor,
  image,
}: RotatingTextProps) => {
  return (
    <div className="flex items-center justify-center [&>div]:hover:[animation-play-state:running]">
      <div className="z-[1] size-full min-w-[30px] text-[10px] animate-[spin_8s_linear_infinite] [animation-play-state:paused]">
        <svg viewBox="0 0 100 100">
          <path
            className="fill-transparent"
            id="curve"
            d="
          M 10, 50
          a 40,40 0 1,1 80,0
          a 40,40 0 1,1 -80,0
          "
          />
          <text
            fill={
              (rotatingTextColor && deprecatedColors[rotatingTextColor]) ||
              deprecatedColors.b100
            }
          >
            <textPath xlinkHref="#curve">
              Watch video · Watch video · Watch video · Watch video ·
            </textPath>
          </text>
        </svg>
      </div>
      <img
        src={image}
        alt="play button"
        className="absolute left-1/2 top-1/2 size-3/5 -translate-x-1/2 -translate-y-1/2 rounded-full"
      />
    </div>
  );
};

Builder.registerComponent(RotatingTextButton, {
  name: interactiveElementsComponentsNames.ROTATING_TEXT_BUTTON,
  inputs: [
    {
      name: "trigger",
      type: "uiBlocks",
      defaultValue: [],
    },
    {
      name: "rotatingTextColor",
      type: "text",
      defaultValue: "b100",
      enum: [...Object.keys(deprecatedColors)],
    },
    {
      name: "image",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      required: true,
      defaultValue:
        "https://cdn.builder.io/api/v1/image/assets%2F15f74e88630d41b6b43ece1273087b6f%2F494285bbefdc42ac8ddbed262c51801f",
    },
  ],
});
